import { createSiteAllowlistFlag } from "@/utils/siteAllowlistFlag";

const truePlaintextCheck = createSiteAllowlistFlag(
  import.meta.env.VITE_FF_TRUE_PLAINTEXT_EMAIL, // "true" => all sites
  import.meta.env.VITE_FF_TRUE_PLAINTEXT_EMAIL_SITES, // comma-separated site allowlist
);

/** Gates creating new true-plaintext emails; existing ones always open. */
export const isTruePlaintextEmailEnabledForSite = (
  siteId: string | undefined,
): boolean => truePlaintextCheck(siteId);
